import { z } from 'zod';
import type {
    CardPointeCredentials,
    CardPointeCredentialsPublic,
    CardPointeCredentialsSecret,
    CardPointeTerminalCredentials,
    DraftCardPointeCredentials,
} from '../../../types/ipg/cardpointe/cardpointe-credential.types';

export const CardPointeCredentialsPublicSchema: z.ZodObject<{
    merchantId: z.ZodString;
}> = z.object({
    merchantId: z.string().min(1),
}) satisfies z.ZodType<CardPointeCredentialsPublic>;

export const CardPointeCredentialsSecretSchema: z.ZodObject<{
    username: z.ZodString;
    password: z.ZodString;
    terminalApiKey: z.ZodOptional<z.ZodString>;
}> = z.object({
    username: z.string().min(1),
    password: z.string().min(1),
    terminalApiKey: z.string().min(1).optional(),
}) satisfies z.ZodType<CardPointeCredentialsSecret>;

export const CardPointeCredentialsSchema: z.ZodType<CardPointeCredentials> =
    CardPointeCredentialsPublicSchema.merge(
        CardPointeCredentialsSecretSchema
    );

export const CardPointeTerminalCredentialsSchema: z.ZodType<CardPointeTerminalCredentials> =
    CardPointeCredentialsSchema.and(
        z.object({ terminalApiKey: z.string().min(1) })
    );

export const DraftCardPointeCredentialsSchema: z.ZodType<DraftCardPointeCredentials> =
    z
        .object({
            merchantId: z.string().min(1).optional(),
            username: z.string().min(1).optional(),
            password: z.string().min(1).optional(),
            terminalApiKey: z.string().min(1).optional(),
        })
        .strict()
        .refine((value) => Object.keys(value).length > 0, {
            message: 'At least one credential field is required',
        });
